// App.vue
<template>
<div id="app">
    <div v-if="isLoading">
        <blurryLoader/>
    </div>
    <template v-else>
        <router-view
            :baseUrl="baseUrl"
            :stripeKey="StripeKey"
            :googleMapsApiKey="googleMapsApiKey"
            @add-to-cart="addItemToCart">
        </router-view>
        <ShoppingCart />
       <!--<ChatWindow v-if="isNotFormPage"/>--> 
        <footer-section v-if="reportPage" />
    </template>
</div>
</template>

<script>
import FooterElement from './components/common/footerElement.vue'
import ShoppingCart from './components/product/shoppingCart.vue'
//import ChatWindow from './components/chat/chatWindow.vue'
import { initializeProducts } from '@/utils/productData'
import blurryLoader from './components/common/blurryLoader.vue'

const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
const StripeKey = process.env.VUE_APP_STRIPE_KEY;
const GoogleMapsApiKey = process.env.VUE_APP_GOOGLE_KEY;

const CACHE_KEY = 'cached_products';
const CACHE_DURATION = 24 * 60 * 60 * 1000;

export default {
    name: 'App',
    components: {
        'footer-section': FooterElement,
        ShoppingCart,
        //ChatWindow,
        blurryLoader
    },
    data() {
        return {
            baseUrl: `${apiEndpoint}`,
            StripeKey: StripeKey,
            googleMapsApiKey: GoogleMapsApiKey,
            isLoading: true
        }
    },
    created() {
        this.initializeApp();
        this.$store.dispatch('captureTrackingData');
    },
    computed: {
        isLoggedin() {
            return this.$store.getters.isAuthenticated;
        },
        isNotFormPage(){
            let rname = this.$route.name;
            return !['FormLoader'].includes(rname);
        },
        reportPage() {
            let rname = this.$route.name;
            return !['CareCalendar', 'Calendar'].includes(rname);
        }
    },
    methods: {
        addItemToCart(item) {
            this.$store.dispatch('addToCart', item);
        },
        async initializeApp() {
            try {
                await this.loadProducts();
            } catch (error) {
                console.error('Failed to initialize app:', error);
            }
        },
        async loadProducts() {
            try {
                const cachedData = localStorage.getItem(CACHE_KEY);

                if (cachedData) {
                    const { timestamp, products } = JSON.parse(cachedData);

                    if (Date.now() - timestamp < CACHE_DURATION) {
                        initializeProducts(products);
                        this.isLoading = false;
                        return products;
                    }
                }

                const response = await this.$axios.get(`${this.baseUrl}/api/get-all-products`);

                if (response.status !== 200) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const products = response.data.products;
                
                localStorage.setItem(CACHE_KEY, JSON.stringify({
                    timestamp: Date.now(),
                    products
                }));
                
                initializeProducts(products);
                this.isLoading = false;
                return products;
            } catch (error) {
                console.error('Error fetching/caching products:', error);
                
                const cachedData = localStorage.getItem(CACHE_KEY);
                if (cachedData) {
                    const { products } = JSON.parse(cachedData);
                    initializeProducts(products);
                    this.isLoading = false;
                    return products;
                }
                
                this.isLoading = false;
                throw error;
            }
        }
    }
}
</script>

<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    z-index: 9999;
}
</style>